export class UIInitializationService {
  static initialized = false;

  static async initializeUI() {
    // Wait for DOM to be ready
    await this.waitForDOM();

    // Only initialize once
    if (this.initialized) {
      // console.log("UI already initialized");
      return;
    }

    try {
      // Initialize Main if it exists
      if (window.Main) {
        // Reset initialization flag in Main
        window.Main.reinit();
      }

      this.initialized = true;
      // console.log("UI initialization complete");
    } catch (error) {
      console.error("Error initializing UI:", error);
      this.initialized = false;
    }
  }

  static async waitForDOM() {
    return new Promise(resolve => {
      if (document.readyState === 'complete') {
        resolve();
      } else {
        window.addEventListener('load', resolve);
      }
    });
  }

  static reset() {
    this.initialized = false;
  }
}